import ContentLoader from 'react-content-loader';
import { useTheme } from '@simplywallst/ui-core';

const RiskRewardLoadingSkeleton = () => {
  const theme = useTheme();
  return (
    <ContentLoader
      foregroundColor={theme.color.spaceGray}
      backgroundColor={theme.color.darkGray}
      height={theme.x11spacePx}
    >
      <circle cx="10" cy="20" r="7" />
      <rect x="25" y="15" rx="5" ry="5" width="220" height="9" />
      <circle cx="10" cy="50" r="7" />
      <rect x="25" y="45" rx="5" ry="5" width="220" height="9" />
      <circle cx="10" cy="80" r="7" />
      <rect x="25" y="75" rx="5" ry="5" width="220" height="9" />
    </ContentLoader>
  );
};

export default RiskRewardLoadingSkeleton;
